"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureToggleDetails = void 0;
var FeatureToggleDetails = /** @class */ (function () {
    function FeatureToggleDetails(featureToggleResponse, featureName) {
        this.isEnabled = false;
        this.expiration = '';
        console.log('FeatureToggleDetails constructor featureToggleResponse :  ', featureToggleResponse);
        if (featureToggleResponse &&
            featureToggleResponse.allocations &&
            featureToggleResponse.allocations[featureName]) {
            this.isEnabled = featureToggleResponse.allocations[featureName].value === 'true' ? true : false;
            this.expiration = featureToggleResponse.allocations[featureName].expiration;
        }
        else {
            this.isEnabled = false;
        }
    }
    return FeatureToggleDetails;
}());
exports.FeatureToggleDetails = FeatureToggleDetails;
//# sourceMappingURL=FeatureToggleResponse.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/models/response/FeatureToggleResponse.js
// module id = 1683
// module chunks = 8